import React, { useMemo } from 'react';
import { useGetAllSpamWords } from '../../../query/spam-word';
import { Input, Spin } from 'antd';
import { renderCategoryWithEmoji } from './utils';
import TablePagination from '../../../components/ui/TablePagination';
import ReactTable from 'react-table';
import Fuse from 'fuse.js';
import CreateSpamWordButton from './CreateSpamWordButton';
import DeleteSpamWordButton from './DeleteSpamWordButton';

const options = {
  includeScore: true,
  keys: ['word'],
};

export default function SpamWords() {
  const { isLoading, data: spamWords } = useGetAllSpamWords();
  const [search, setSearch] = React.useState('');

  const fuse = new Fuse(spamWords, options);
  const filtered = fuse.search(search);

  const columnDefs = useMemo(() => {
    return [
      {
        Header: () => {
          return (
            <>
              <p style={{ marginBottom: 5 }}>Word</p>
              <Input
                className="input-small"
                defaultValue={search}
                placeholder="Search by word ..."
                onChange={e => setSearch(e.target.value)}
              />
            </>
          );
        },
        accessor: 'word',
      },
      {
        Header: 'Category',
        accessor: 'category',
        Cell: ({ value }) => renderCategoryWithEmoji(value),
      },
      {
        Header: 'Created At',
        accessor: 'createdAt',
        Cell: ({ value }) => new Date(value).toLocaleString(),
      },
      {
        Header: '',
        accessor: 'actions',
        Cell: ({ original }) => {
          return <DeleteSpamWordButton spamWord={original} />;
        },
      },
    ];
  }, []);
  return (
    <Spin spinning={isLoading}>
      <CreateSpamWordButton />
      <ReactTable
        PaginationComponent={TablePagination}
        columns={columnDefs}
        data={search ? filtered.map(({ item }) => item) : spamWords}
        defaultPageSize={15}
        firstText={<i className="material-icons">first_page</i>}
        lastText={<i className="material-icons">last_page</i>}
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        previousText={<i className="material-icons">chevron_left</i>}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPaginationBottom
        sortable={false}
      />
    </Spin>
  );
}
